import Image from 'next/image';
import {
  ButtonBack,
  ButtonNext,
  CarouselProvider,
  Slide,
  Slider,
} from 'pure-react-carousel';

import { useMediaQuery } from '@/hooks';
import type { ProductModelType } from '@/models/api';
import type { OrderPlan } from '@/models/cart/order-plan';
import { useStore } from '@/models/root-store';

import RecommendationProductTile from '../RecommendationProductTile/RecommendationProductTile';

export type RecommendationProductsType = {
  products: string[];
  plan: OrderPlan;
  productRecommendationTitle: string;
};

export const RecommendationProductsContainer: React.FC<
  RecommendationProductsType
> = ({ products, plan, productRecommendationTitle }) => {
  const {
    productStore: { productsLookup },
  } = useStore();

  const isMediumDevice = useMediaQuery(
    `(min-width:768px) and (max-width:1023px`,
  );

  const isLg = useMediaQuery(`(min-width: 1024px) and (max-width:1279px`);
  const isXL = useMediaQuery(`(min-width: 1280px) and (max-width:1535px`);
  const isXXL = useMediaQuery(`(min-width: 1536px)`);
  let height: any;
  let slides: any;
  if (isMediumDevice) {
    height = 220;
    slides = 2;
  } else if (isLg) {
    height = 200;
    slides = 2;
  } else if (isXL) {
    height = 200;
    slides = 2.5;
  } else if (isXXL) {
    height = 220;
    slides = 2.5;
  } else {
    height = 200;
    slides = 2.2;
  }

  const recommendedProducts = products
    .map((productSku: string) => productsLookup[productSku])
    .filter((prod: any) => prod) as ProductModelType[];

  return (
    <div className="flex w-full flex-col pb-0 md:pb-8">
      <div className="mx-4 flex justify-between font-interSemibold text-4xl md:mx-0">
        {productRecommendationTitle}
      </div>
      <div className="flex w-full flex-row flex-wrap py-2 md:-ml-2">
        <CarouselProvider
          naturalSlideWidth={100}
          naturalSlideHeight={height}
          totalSlides={products?.length || 0}
          visibleSlides={slides}
          className="relative px-2 md:px-0"
        >
          <Slider>
            {recommendedProducts.map((product: any, j: number) => {
              return (
                <Slide key={j} index={j}>
                  {product && (
                    <div
                      key={product.sku}
                      className="flex size-full justify-between p-2"
                    >
                      <RecommendationProductTile
                        key={product.sku}
                        plan={plan}
                        product={product}
                      />
                    </div>
                  )}
                </Slide>
              );
            })}
          </Slider>
          <ButtonBack className="absolute left-[-30px] top-0 hidden h-full disabled:hidden md:block md:pt-8 lg:pt-0 xl:pt-4">
            <Image
              src="/assets/icons/next-button.svg"
              alt="Previous icon"
              style={{ transform: 'scaleX(-1)' }}
              width={48}
              height={48}
            />
          </ButtonBack>
          <ButtonNext className="absolute right-[-30px] top-0 hidden h-full disabled:hidden md:block md:pt-8 lg:pt-0 xl:pt-4">
            <Image
              src="/assets/icons/next-button.svg"
              alt="Next icon"
              width={48}
              height={48}
            />
          </ButtonNext>
        </CarouselProvider>
      </div>
    </div>
  );
};
